import { getPromoBanner } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/__internal__/getPromoBanner";
import { IMP_TO_PROMO_BANNER_MAP } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/__internal__/siteBannersConsts";
import { PromoBannerType } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/bannerOrder";
import { IConductorComponentData } from "@faire/retailer-visitor-shared/features/Conductor/types";
import { FeatureName } from "@faire/web-api--source/indigofair/data/FeatureName";
import { IProductMessageByViewport } from "@faire/web-api--source/indigofair/retailer/IProductMessageByViewport";

// Using Map to maintain insertion order. This will be important to determine rotation
type ConductorBannerMap = Map<
  PromoBannerType,
  IConductorComponentData | undefined
>;
type IMPBannerMap = Map<PromoBannerType, IProductMessageByViewport>;
type PromoBannerMap = Map<PromoBannerType, React.ReactNode>;

export const mapConductorToPromoBanners = (
  conductorData: IConductorComponentData | undefined
): ConductorBannerMap => {
  const bannerMap = new Map();

  const getPromoBannerTypeFromFeatureName = (): PromoBannerType => {
    switch (conductorData?.featureName) {
      case FeatureName.FIRST_ORDER_INCENTIVE:
      case FeatureName.FIRST_ORDER_INCENTIVE_AUTO_EXTEND:
      case FeatureName.FIRST_ORDER_INCENTIVE_LAST_CHANCE:
        return PromoBannerType.FIRST_ORDER_INCENTIVE;
      default:
        return PromoBannerType.BANNER_TYPE_UNKNOWN;
    }
  };

  // For now, we only have FOI banner. We will need to adjust this when we receivee array of banners
  bannerMap.set(getPromoBannerTypeFromFeatureName(), conductorData);
  return bannerMap;
};

export const mapImpToPromoBanners = (
  bannersArray: IProductMessageByViewport[] | undefined
): IMPBannerMap => {
  const bannerMap: IMPBannerMap = new Map();

  bannersArray?.forEach((banner) => {
    const campaignName = banner.mobile_and_above
      ?.campaign_name as PromoBannerType;
    const bannerType =
      IMP_TO_PROMO_BANNER_MAP[campaignName] ??
      PromoBannerType.BANNER_TYPE_UNKNOWN;
    bannerMap.set(bannerType, banner);
  });

  return bannerMap;
};

export const mapPromoBanners = (
  banners: PromoBannerType[] | undefined
): PromoBannerMap => {
  const bannerMap: PromoBannerMap = new Map();

  banners?.forEach((bannerType) => {
    bannerMap.set(bannerType, getPromoBanner(bannerType));
  });

  return bannerMap;
};
